import { memo } from 'react'

export default memo(function UploadIcon(props: any) {
  return (
    <svg
      width={props.width ? props.width : '48px'}
      height={props.height ? props.height : '48px'}
      viewBox="0 0 48 48"
      fill={props.color ? props.color : '#888'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9366 6C22.5306 6 22.1246 6.17949 21.9216 6.44872L12.3806 14.7949C11.8731 15.2436 11.8731 15.9615 12.3806 16.4103C12.8881 16.859 13.7001 16.859 14.2076 16.4103L21.7186 9.85897L21.7186 32.9231C21.7186 33.5513 22.3276 34 22.9366 34C23.5456 34 24.1546 33.4615 24.1546 32.9231L24.1546 9.76923L31.767 16.5C32.2745 16.9487 33.0865 16.9487 33.594 16.5C33.797 16.3205 34 15.9615 34 15.6923C34 15.4231 33.8985 15.1538 33.594 14.8846L23.8501 6.26923C23.6471 6.08974 23.3426 6 22.9366 6Z"
        fill={props.color ? props.color : '#888'}
      ></path>
      <path
        d="M42.6423 41.9375H5.25326C4.52219 41.9375 4 41.3375 4 40.7375C4 40.1375 4.62663 39.5375 5.25326 39.5375H42.7467C43.4778 39.5375 44 40.1375 44 40.7375C44 41.3375 43.3734 41.9375 42.6423 41.9375Z"
        fill={props.color ? props.color : '#888'}
      ></path>
    </svg>
  )
})
